import React from 'react'
import { PopOver, Button, Flex, styled, Grid } from '@fareye/ui'
import { ActiveText, DownIconStyle } from '../../../style/styled'
import { useTranslation } from '@fareye/common'
import { ModeAir, ModeRail, ModeOcean, ModeRoad } from '@fareye/utils'
interface ICarrierPopover {
  transporters: any[]
}
const VerticalLine = styled.div`
  border-left: 2px dotted black;
  height: 45px;
`
const NameStyle = styled.span`
  font-size: 12px;
  color: black;
  padding: 2px 4px;
  font-weight: bolder;
`
const RouteStyle = styled.span`
  font-size: 12px;
  padding: 2px 4px;
`
export const IconContainer = styled.div`
  margin-left: 20px;
  padding: 0px 5px;
  cursor: pointer;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.75);
`
const Svg: any = {
  air: ModeAir,
  ocean: ModeOcean,
  road: ModeRoad,
  rail: ModeRail
}

export default function CarrierPopover({ transporters }: ICarrierPopover) {
  const { t } = useTranslation()
  function CarrierTransporter(packageLegs: any[]) {
    let currentDecidedFlag = false
    return packageLegs.map((ele, i: number) => {
      const { transporterName, attachRouteString, activeStatus } = ele
      currentDecidedFlag =
        activeStatus === 'active' && !currentDecidedFlag ? true : false
      return (
        <Flex style={{ padding: '6px 0px' }} key={i} column>
          {activeStatus === 'active' && currentDecidedFlag && (
            <ActiveText>{t('Current Carrier')}</ActiveText>
          )}
          <NameStyle>{transporterName}</NameStyle>
          <RouteStyle>{attachRouteString}</RouteStyle>
        </Flex>
      )
    })
  }
  function CarrierTimeline(packageLegs: any[]) {
    return packageLegs.map((leg, index) => {
      const { transportMode } = leg
      const Icon = Svg[transportMode]
      return (
        <Flex column alignItemsCenter key={index}>
          {Icon && <Icon style={{ height: '21px' }} />}
          {packageLegs.length - 1 !== index && <VerticalLine />}
        </Flex>
      )
    })
  }
  return (
    <PopOver style={{ margin: '0 10px' }} variant="arrow Bottom-Center">
      <IconContainer>
        <DownIconStyle size={8} />
      </IconContainer>
      <PopOver.Body
        style={{ boxShadow: '0px -1px 10px -1px rgba(0,0,0,0.75)' }}
      >
        <Grid
          gridGap={'10px'}
          style={{ padding: '10px 15px' }}
          gridTemplateColumns={'1fr 3fr'}
        >
          <Flex column>{CarrierTimeline(transporters)}</Flex>
          <Flex column>{CarrierTransporter(transporters)}</Flex>
        </Grid>
      </PopOver.Body>
    </PopOver>
  )
}
